import React, { useEffect, useRef } from 'react';
import './Modal.scss';

var Modal = function Modal(_ref) {
  var show = _ref.show,
      title = _ref.title,
      onClose = _ref.onClose,
      children = _ref.children;
  var ref = useRef(null);

  var handleClose = function handleClose() {
    if (onClose) {
      onClose();
    }
  };

  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      handleClose();
    }
  };

  var handleClickEscape = function handleClickEscape(event) {
    if (event.key === 'Escape') {
      handleClose();
    }
  };

  var handleCloseKeyDown = function handleCloseKeyDown(event) {
    if (event.key === 'Enter') {
      handleClose();
    }
  };

  useEffect(function () {
    if (onClose) {
      document.addEventListener('click', handleClickOutside, true);
      document.addEventListener('keydown', handleClickEscape, true);
      return function () {
        document.removeEventListener('click', handleClickOutside, true);
        document.removeEventListener('keydown', handleClickEscape, true);
      };
    }
  });
  return show && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pwd-modal-background"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pwd-modal-component",
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "pwd-title-box"
  }, /*#__PURE__*/React.createElement("span", null, title)), onClose && /*#__PURE__*/React.createElement("span", {
    className: "pwd-close-button noselect",
    onClick: handleClose,
    role: "button",
    tabIndex: 0,
    onKeyDown: handleCloseKeyDown
  }, "x"), /*#__PURE__*/React.createElement("div", {
    className: "pwd-content-box"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "pwd-footer-box"
  })));
};

export default Modal;